// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4d8e5b5","455":"6902d249"}[chunkId] + ".chunk.js";
};